import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const FormValidation = (props) => {
  const { item, validationState } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  return (
    validationState &&
    validationState.requiredGroup === item.hook && (
      <div className="FormValidation">
        <p className="FormValidation-copy">{t(validationState.error)}</p>
      </div>
    )
  )
}

FormValidation.propTypes = {
  item: PropTypes.any,
  validationState: PropTypes.any
}

export default FormValidation
